module.exports = __webpack_public_path__ + "static/media/image-768.8cb14694.webp";